import React from 'react';
import { useTranslation } from "react-i18next";

import * as Icons from "assets/icons";

import { useAll as useSpheres } from "modules/sphere/hooks";
import { useAll as useOrganizations } from "modules/organization/hooks";

import * as Grid from "components/Grid";

import Input from "components/Input";
import Select from "components/Select";
import Button from "components/Button";
import Label from 'components/Label';
import { useEnums } from 'hooks';

const FilterList = ({ params, setParams, setSearch }) => {
  const { t, i18n } = useTranslation();

  const sphere = useSpheres();
  const organization = useOrganizations();

  const { items: functionLevel, isFetched: isFunctionLevelFetched } = useEnums("FunctionLevel");

  return (
    <Grid.Row gutter={[20, 20]} align="bottom">
      <Grid.Col xs={8}>
        <Label title={t("column_organization")}>
          <Select
            onChange={v => setParams({ organization_id: v })}
            showSearch
            options={[
              { label: t('all_organization'), value: '' },
              ...organization.items.map(item => ({ label: item.name[i18n.language], value: item.id }))
            ]}
            value={Number(params.organization_id) || ''}
            placeholder={t('column_organization')}
            disabled={!organization.isFetched}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={4}>
        <Label title={t("column_function_code")}>
          <Input
            onChange={e => setParams({ function_code: e || undefined })}
            placeholder={t('column_function_code')}
            value={params.function_code}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={10}>
        <Label title={t("column_function_name")}>
          <Input
            onChange={e => setParams({ function_name: e || undefined })}
            placeholder={t('column_function_name')}
            value={params.function_name}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={4}>
        <Label title={t("column_function_status")}>
          <Select
            onChange={e => setParams({ personal: e })}
            options={[
              {
                label: t('personal_all'),
                value: ''
              },
              {
                label: t('personal_transferred'),
                value: 'transferred'
              },
              {
                label: t('personal_not_transferred'),
                value: 'not_transferred'
              }
            ]}
            placeholder={t('column_function_status')}
            value={params.personal || ''}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={8}>
        <Label title={t("column_sphere")}>
          <Select
            onChange={v => setParams({ sphere_id: v })}
            showSearch
            options={[
              { label: t('all_sphere'), value: '' },
              ...sphere.items.map(item => ({ label: item.name, value: item.id }))
            ]}
            value={Number(params.sphere_id) || ''}
            placeholder={t('column_sphere')}
            disabled={!sphere.isFetched}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={8}>
        <Label title={t("column_degree")}>
          <Select
            onChange={v => setParams({ function_level: v })}
            showSearch
            options={isFunctionLevelFetched && functionLevel.length ? [
              { label: t('all'), value: '' },
              ...Object.values(functionLevel).map(item => ({ label: t(item), value: item }))
            ] : [
              { label: t('all'), value: '' }
            ]}
            value={params.function_level || ''}
            placeholder={t('column_degree')}
          />
        </Label>
      </Grid.Col>

      <Grid.Col xs={2}>
        <Button
          background='blue'
          color='white'
          border='blue'
          radius='sm'
          onClick={() => setSearch(prev => prev + 1)}
        >
          <Icons.Search /> {t('find')}
        </Button>
      </Grid.Col>
    </Grid.Row>
  )
}

export default FilterList;